/* Chahal Agri Farms — Member Price live sync (v56, v100 Diwali-aware)
 * -------------------------------------------------
 * The "FAMILY / Members Price" PDP block
 * (blocks/chahal-member-price.liquid) renders variant.price * rate for the
 * FIRST variant only and does NOT re-render when the shopper changes the
 * size — so a 5 Litre selection kept showing the 250 ml member price. This
 * keeps the member value in sync with the CURRENTLY selected variant by
 * mirroring the theme's own (reactive) price element and applying the same
 * Family discount (round to whole paise, like the block's
 * `| times: rate | round`). Progressive enhancement: if this never runs,
 * the block just keeps its server-rendered value.
 *
 * v100: the rate comes from the block's data-rate (0.88 normally, 0.8 during
 * the Diwali Sale). During Diwali the visible price is the 15%-off sale price,
 * so the real base price is read from data-caf-base (paise) when present.
 */
(function () {
  'use strict';

  var DEFAULT_RATE = 0.88; /* 12% Chahal Family discount (code FAMILY12) */

  /* Parse "Rs. 9,099.00" -> integer paise (909900). Anchored on the first
     digit so the period in the "Rs." prefix is ignored. */
  function parseCents(txt) {
    var m = String(txt == null ? '' : txt).match(/[\d][\d,]*(?:\.\d+)?/);
    if (!m) return null;
    var rupees = parseFloat(m[0].replace(/,/g, ''));
    return isFinite(rupees) ? Math.round(rupees * 100) : null;
  }

  function update() {
    var blocks = document.querySelectorAll('.cmp-price');
    if (!blocks.length) return;
    blocks.forEach(function (cmp) {
      var valEl = cmp.querySelector('.cmp-price__value');
      if (!valEl) return;

      var rate = parseFloat(cmp.getAttribute('data-rate'));
      if (!isFinite(rate) || rate <= 0 || rate >= 1) rate = DEFAULT_RATE;

      var scope = cmp.closest('.product-details') ||
        cmp.closest('.shopify-section') || document;
      var priceEl = scope.querySelector('product-price .price__regular') ||
        scope.querySelector('product-price .price') ||
        scope.querySelector('.price__regular') ||
        scope.querySelector('.price');
      if (!priceEl) return;

      var base = priceEl.getAttribute && priceEl.getAttribute('data-caf-base');
      var cents = base ? parseInt(base, 10) : parseCents(priceEl.textContent);
      if (cents == null || !isFinite(cents)) return;

      var member = Math.round(cents * rate);
      var prefix = (valEl.textContent.match(/^[^\d]*/) || ['Rs. '])[0] || 'Rs. ';
      var next = prefix + (member / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      if (valEl.textContent.trim() !== next.trim()) valEl.textContent = next;
    });
  }

  function boot() {
    update();

    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(update, 120);
    });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name;
      if (n && /(^id$|variant|Size-|option)/i.test(n)) setTimeout(update, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(update, 800);
  setTimeout(update, 1800);
})();
